import React, { useState, useEffect } from "react";
import NavBar from "../Utils/NavBar";
import { FaTimesCircle } from "react-icons/fa";
import Slider from "./Slider";
require("../../assets/stylesheets/Main/Main.css");

// FIRST SECTION OF THE MAIN PAGE
function MainSection() {
  return (
    <div className="contentBack">
      <div className="content-shadow">
        <div className="title-side">
          <div className="main-title-container">
            <h1 className="main-title">Feria Ingenio</h1>
          </div>
          <p>
            {" "}
            <i>Campus Tegucigalpa</i>{" "}
          </p>
        </div>
        <div className="logo-side">
          <div className="back-logo"></div>
          <img src={require("../../assets/images/logoFeria.png")} />
        </div>
      </div>
    </div>
  );
}

// BANNER OR AD OF THE EVENT
const Banner = () => {
  const [visibility, setVisibility] = useState(true);

  useEffect(() => {}, [visibility]);

  const handleVisibility = () => {
    setVisibility(false);
  };

  return (
    <a onClick={handleVisibility} className={visibility ? "banner" : "hide"}>
      <span>
        <FaTimesCircle />{" "}
      </span>
      <div className="banner-img">
        <img src={require("../../assets/images/banner1.jpeg")} />
      </div>
    </a>
  );
};

// CAREERS PARTICIPATING IN THE EVENT
function Careers() {
  return (
    <div className="careers-container">
      <h1>Carreras que participan</h1>
      <div className="careers">
        <article className="careers-item">
          <img src={require("./../../assets/images/ingenieria.png")} alt="" />
          <h4>Computación/Industrial/Electrónica</h4>
        </article>
        <article className="careers-item">
          <img src={require("./../../assets/images/ingenierias.png")} alt="" />
          <h4>Informatica</h4>
        </article>
        <article className="careers-item">
          <img src={require("./../../assets/images/marketing.png")} alt="" />
          <h4>Marketing</h4>
        </article>
        <article className="careers-item">
          <img src={require("./../../assets/images/gerencia.png")} alt="" />
          <h4>Gerencia de Negocios</h4>
        </article>
        <article className="careers-item">
          <img src={require("./../../assets/images/turismo.png")} alt="" />
          <h4>Turismo</h4>
        </article>
        <article className="careers-item">
          <img src={require("./../../assets/images/derecho.png")} alt="" />
          <h4>Derecho</h4>
        </article>
      </div>
    </div>
  );
}

// SLOGAN
function Slogan() {
  return (
    <div className="slogan-container">
      <div className="content-shadow slogan">
        <h1>Ingenio | Creatividad | Desarrollo</h1>
      </div>
      <div className="up-side"></div>
      <div className="down-side"></div>
    </div>
  );
}

// QUOTATION
function Quotation() {
  return (
    <div className="Quotation">
      <div className="quote">
        <i>
          «No importa cuántas restricciones imponga la civilización al
          individuo, él encuentra la manera de eludirlo. El ingenio es la mejor
          válvula de escape que el hombre moderno ha desarrollado; cuanta más
          civilización, más represión, más necesidad hay de ingenio.».
        </i>
      </div>
      <div className="quote-author">Sigmund Freud.</div>
    </div>
  );
}

// EXPORT MAIN COMPONENT
function Main() {
  return (
    <div className="Main">
      <Banner />
      <NavBar />
      <MainSection />
      <Careers />
      <Slogan />
      <Slider />
      <Quotation />
    </div>
  );
}

// EXPORTING MAIN FUNCTION
export default Main;
